import { combineReducers } from 'redux-immutable';
import { createResponsiveStateReducer } from 'redux-responsive';

// global store
import bannerAppData from 'src/store/appBanners/slice';
import client from 'src/store/client/reducers';
import enqueue from 'src/store/enqueue/reducers';
import feedback from 'src/store/feedback/slices';
import headerBanner from 'src/store/headerBanner/slice';
import headerWidget from 'src/store/headerWidget/reducers';
import hotelImages from 'src/store/hotelImages/slice';
import logo from 'src/store/logo/reducers';
import menu from 'src/store/menu/slice';
import wishlist from 'src/store/wishlist/slice';

import previousFilters from 'src/store/previousFilters/slice';
import cashback from 'src/store/cashback/slice';
import metadata from './metadata/reducer';

import hotels from './hotels/slice';
import hotelsImages from './hotelsImages/reducer';
import hotelViewed from './hotelViewed/reducer';

import filters from './filters/reducer';
import filtrationStatus from './filters/status_reducer';
import priceSubscription from './priceSubcription/slice';
import searcher from './searcher/reducer';
import sorting from './sorting/reducer';

import linked from './linked/reducer';

import mobile from './mobile/reducer';
import view from './view/reducer';

import map from './map/slice';

const rootReducer = combineReducers({
  // Global store:
  feedback,
  client,
  menu,
  logo,
  enqueue,
  headerWidget,
  headerBanner,
  wishlist,
  bannerAppData,
  cashback,

  // Meta data:
  metadata,

  // Hotel:
  hotels,
  hotelsImages,
  hotelViewed,
  hotelImages,

  // Filters/Search/Sorting:
  filters,
  previousFilters,
  filtrationStatus,
  sorting,
  searcher,
  priceSubscription,

  // View/Mobile:
  mobile,
  view,

  // Map:
  map,

  // Linked countries/months/recommended:
  linked,

  // Browser:
  browser: createResponsiveStateReducer({
    small: 720,
    medium: 960,
    large: 1279,
    extraLarge: 1600,
  }),
});

export default rootReducer;
